import { Option } from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React, { useContext, useEffect, useState } from 'react'

import { updateQuoteMutation } from '../hooks'
import { useQuote } from '../hooks/useQuote'
import { ProviderContext } from '../Provider'
import { EditableDropdownPanel } from './shared'

interface ExcessDropdownProps {
  voluntaryExcess: number
  compulsoryExcess: number
  isMobile: boolean
  onInfoClick?: () => void
}

export const ExcessDropdown = ({ voluntaryExcess, compulsoryExcess, isMobile, onInfoClick }: ExcessDropdownProps) => {
  const {
    state: { quoteId },
  } = useContext(ProviderContext)
  const quote = useQuote()
  const { updateQuote } = updateQuoteMutation()

  const [excessValue, setExcess] = useState(voluntaryExcess)

  const handleUpdateExcess = (newExcess: number) => {
    setExcess(newExcess)
    updateQuote({
      variables: {
        id: quoteId as string,
        actions: [{ setVoluntaryExcess: { voluntaryExcess: newExcess } }],
      },
    })
  }

  useEffect(() => {
    if (quote?.possibleVoluntaryExcesses) {
      const { possibleVoluntaryExcesses } = quote
      const maxExcess = possibleVoluntaryExcesses[possibleVoluntaryExcesses.length - 1]
      excessValue > maxExcess && handleUpdateExcess(maxExcess)
    }
  }, [])

  return (
    <EditableDropdownPanel
      primaryTitle="VOLUNTARY EXCESS"
      secondaryTitle="COMPULSORY EXCESS"
      secondaryInfo={`£${compulsoryExcess}`}
      infoTitle="All policy excesses"
      options={quote?.possibleVoluntaryExcesses?.map((o: any) => ({ value: o, label: `£${o}` }))}
      preFilledValue={`£${excessValue}`}
      handleDropdownChange={(option: Option) => {
        const newExcess = Number(option.value)
        DataLayer.customEvent({
          eventName: 'submit',
          section: 'excess edit',
          eventType: 'form submit',
        })
        handleUpdateExcess(newExcess)
      }}
      onInfoClick={onInfoClick}
      dataDogActionName="Edit Excess"
    />
  )
}
